// extracted by mini-css-extract-plugin
module.exports = {"preloader":"loader_preloader__1LZak","status":"loader_status__1wyQH","bouncing-loader":"loader_bouncing-loader__cwpRa"};